module.exports = __webpack_public_path__ + "img/member-pic1.408abd4e.png";